import React from 'react';
import { useIntl } from 'react-intl';
import { faLinkSlash } from '@fortawesome/pro-light-svg-icons/faLinkSlash';
import { TypedMemo } from '../../common/types';
import { ConfirmDialog } from '../../common/views/modals/confirmDialog/ConfirmDialog';
import { ConfirmDialogIconMark } from '../../common/views/modals/confirmDialog/ConfirmDialogMark';
import { youtubeConnectionMessages } from '../../music24/youtubeConnection/youtubeConnectionMessages';

interface ConnectionDisconnectModalProps {
  isOpen: boolean;
  serviceName: string;
  /** The request runs: the dialog stays open with a spinner (design dialogs a4). */
  isBusy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  /** YouTube: one sign-in for posting and analytics, so the text says that both stop. */
  isYouTube?: boolean;
}

/**
 * Disconnecting deletes the stored sign-in and every number we read with it,
 * on the server, for good. That is worth one question.
 * design: dialogs a1 (the confirm dialog)
 */
const ConnectionDisconnectModalComponent: React.FC<ConnectionDisconnectModalProps> = ({
  isOpen,
  serviceName,
  isBusy,
  onCancel,
  onConfirm,
  isYouTube = false,
}) => {
  const intl = useIntl();

  return (
    <ConfirmDialog
      isOpen={isOpen}
      tone="danger"
      mark={<ConfirmDialogIconMark tone="danger" icon={faLinkSlash} />}
      title={intl.formatMessage(
        { id: 'app.sml.catalog.connection.disconnect_title', defaultMessage: 'Disconnect {service}?' },
        { service: serviceName }
      )}
      description={
        isYouTube
          ? intl.formatMessage(youtubeConnectionMessages.disconnectBody)
          : intl.formatMessage({
              id: 'app.sml.catalog.connection.disconnect_body',
              defaultMessage:
                'We delete your sign-in and stop new reads. Streaming keeps the numbers we already read. Connect again later to continue the same history.',
            })
      }
      cancelLabel={intl.formatMessage({ id: 'app.sml.catalog.connection.disconnect_keep', defaultMessage: 'Keep it' })}
      confirmLabel={intl.formatMessage({
        id: 'app.sml.catalog.connection.disconnect_confirm',
        defaultMessage: 'Yes, disconnect',
      })}
      isBusy={isBusy}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export const ConnectionDisconnectModal = TypedMemo(ConnectionDisconnectModalComponent);
